import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "icon-btn__content" }
const _hoisted_2 = {
  key: 0,
  class: "icon-btn__tooltip"
}

import { computed, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'IconButton',
  props: {
    disabled: { type: Boolean },
    icon: {},
    outlined: { type: Boolean },
    yellow: { type: Boolean },
    href: {},
    tag: { default: 'button' },
    tooltip: {}
  },
  setup(__props: any) {

const props = __props

const tooltipActive = ref(false)

const classes = computed(() => {
  return {
    'icon-btn': true,
    'icon-btn--disabled': props.disabled,
    'icon-btn--outlined': props.outlined,
    'icon-btn--yellow': props.yellow,
  }
})

/**
 * Use `scale-transition` when showing the tooltip.
 * Use `fade-transition` when hiding the tooltip.
 */
const computedTransition = computed(() => {
  return tooltipActive.value ? 'scale-transition' : 'fade-transition'
})

const elementTag = computed(() => {
  const tag = (props.href && 'a') || props.tag || 'div'
  return tag
})

/**
 * Hide or show the tooltip when there is a tooltip present.
 */
function toggleTooltip(show: boolean): void {
  if (typeof props.tooltip !== 'undefined') {
    tooltipActive.value = show
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(elementTag.value), {
    class: _normalizeClass(classes.value),
    disabled: elementTag.value === 'button' && __props.disabled,
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (toggleTooltip(true))),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (toggleTooltip(false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("span", {
          class: _normalizeClass(["iconfont", __props.icon])
        }, null, 2),
        _createVNode(_Transition, { name: computedTransition.value }, {
          default: _withCtx(() => [
            (tooltipActive.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.tooltip), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["name"])
      ])
    ]),
    _: 1
  }, 40, ["class", "disabled"]))
}
}

})